import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import AutoWidthSelect from '../AutoWidthSelect';
import withStyles from '../../decorators/withStyles';
import { plural, xlt } from '../../utils/utils';
import styles from './ZillowPlaceType.css';


class ZillowPlaceType extends Component {

  static propTypes = {
    handleChange: PropTypes.func.isRequired,
    zillowPlaceType: PropTypes.string.isRequired,
    zillowPlaceTypeOptions: PropTypes.array.isRequired,
  };

  render() {
    const { isEmbed, handleChange, zillowPlaceType, zillowPlaceTypeOptions } = this.props;

    const singleOption = () => {
      if (zillowPlaceTypeOptions.length > 0) {
        const options = zillowPlaceTypeOptions.filter((k) => k.placeTypeValue === zillowPlaceType);
        if (options.length > 0) {
          const placeLabel = options[0].placeTypeLabel.replace('major ', '');
          return <span><var>{plural(placeLabel)}</var> in <var>{options[0].containerName}</var></span>;          
        }
      }
      return '';
    };

    const options = zillowPlaceTypeOptions.map((item) => {
      return {
        text: <span><var>{item.containerName}</var> by <var>{item.placeTypeLabel}</var></span>,
        value: item.placeTypeValue,
      };
    });

    const multiOption = (
      <AutoWidthSelect
        options={options}
        handleChange={handleChange}
        defaultValue={zillowPlaceType}
      />
    );

    return (
      <div className="ZillowPlaceType">
        {(options.length < 2 || isEmbed) ? singleOption() : multiOption}
      </div>
    );
  }
}

export default withStyles(styles)(ZillowPlaceType);
